import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SuiPagination } from "./components/pagination";
var SuiPaginationModule = /** @class */ (function () {
    function SuiPaginationModule() {
    }
    SuiPaginationModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    exports: [SuiPagination],
                    declarations: [SuiPagination],
                    providers: []
                },] },
    ];
    /** @nocollapse */
    SuiPaginationModule.ctorParameters = function () { return []; };
    return SuiPaginationModule;
}());
export { SuiPaginationModule };
//# sourceMappingURL=pagination.module.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/collections/pagination/pagination.module.js
// module id = 1083
// module chunks = 0